// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

.icon-button_container_sNqP2 {
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    font-size: 0.75rem;
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    color: var(--looks-secondary);
    border-radius: 0.5rem;
}

.icon-button_container_sNqP2 + .icon-button_container_sNqP2 {
    margin-top: 1.25rem;
}

.icon-button_title_WscjN {
    margin-top: 0.5rem;
    text-align: center;
}

.icon-button_disabled_fETpn {
    opacity: 0.5;
    pointer-events: none;
}

.icon-button_container_sNqP2:active {
    background-color: var(--looks-light-transparent);
}
`, "",{"version":3,"sources":["webpack://./src/components/icon-button/icon-button.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,2DAA2D;IAC3D,6BAA6B;IAC7B,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,gDAAgD;AACpD","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n.container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    cursor: pointer;\n    font-size: 0.75rem;\n    font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n    color: var(--looks-secondary);\n    border-radius: 0.5rem;\n}\n\n.container + .container {\n    margin-top: 1.25rem;\n}\n\n.title {\n    margin-top: 0.5rem;\n    text-align: center;\n}\n\n.disabled {\n    opacity: 0.5;\n    pointer-events: none;\n}\n\n.container:active {\n    background-color: var(--looks-light-transparent);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `icon-button_container_sNqP2`,
	"title": `icon-button_title_WscjN`,
	"disabled": `icon-button_disabled_fETpn`
};
export default ___CSS_LOADER_EXPORT___;
